import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'
import SuperAdminDashboard from '@/views/super-admin/dashboard'

export const Route = createFileRoute('/_authenticated/super-admin-dashboard')({
  beforeLoad: async () => {
    const auth = useAuthStore.getState().auth;

    // Check if user is authenticated
    if (!auth.accessToken || !auth.user) {
      throw redirect({
        to: '/auth/login',
      });
    }

    // Check if user has super admin role
    // Check if user has super admin role
    if (auth.user.role !== 'Super Admin' && auth.user.role_name !== 'Super Admin') {
      throw redirect({
        to: '/dashboard',
      });
    }
  },
  component: SuperAdminDashboard,
})